// Import utilities
const {
	isDefined
} = _uo.utility;

import { getConditionsGroupById } from '@builder-legacy/item/conditions/utilities';

/**
 * Returns the data of a condition using the condition ID
 *
 * @param {Object} options                   The options
 * @param {String} options.conditionsGroupId The unique ID of the conditions group
 * @param {String} options.conditionId       The unique ID of the condition
 * @return {Condition}                       The condition
 */
const getConditionById = ( { conditionsGroupId, conditionId } ) => {
	// Default response
	let condition = null;

	// Get the ConditionsGroup
	const conditionsGroup = getConditionsGroupById( {
		conditionsGroupId: conditionsGroupId,
	} );

	// Check if it's defined
	if ( isDefined( conditionsGroup ) ) {
		// Look for the condition
		if ( conditionsGroup.hasCondition( conditionId ) ) {
			condition = conditionsGroup.getCondition( conditionId );
		}
	}

	return condition;
};

export default getConditionById;
